export default __webpack_public_path__ + "static/media/PERL.ef2b2365.png";